module.exports = __webpack_public_path__ + "img/011.c4dd5fe4.png";